import { useCallback } from 'react';

const useEventHandlersForCreatableDropdowns = ({
  openDialogAndSetInitialName,
  onChange
}) => {
  const handleOnChange = useCallback(
    v => {
      if (v?.isCreatable) {
        openDialogAndSetInitialName(v?.label || v?.displayText);
      }
      onChange(v);
    },
    [onChange, openDialogAndSetInitialName]
  );

  const handleOnCancel = useCallback(() => {
    onChange(null);
  }, [onChange]);

  return { handleOnChange, handleOnCancel };
};

export default useEventHandlersForCreatableDropdowns;
